import { NotificationsPage } from './views';
import { ROUTE } from './utils';

const { name, path } = ROUTE;
const routes = [
    {
        name,
        path,
        component: NotificationsPage,
        meta: {
            title: 'Notifications',
        },
    },
];

export default routes;
